module.exports = __webpack_public_path__ + "static/original-seven-layers-of-osi-model-6469d7a22b206f1dc429e2ad43231516.png";